export default __webpack_public_path__ + "static/media/269.7fd029ed.png";